import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type CookieConsentMap = Record<string, boolean>;

export interface CookieState {
  /** When true, the cookie mini bar is not shown (survives reload via redux-persist). */
  hasCompletedBanner: boolean;
  /** Last committed choices per cookie key. */
  consent: CookieConsentMap | null;
}

const initialState: CookieState = {
  hasCompletedBanner: false,
  consent: null,
};

const cookieSlice = createSlice({
  name: 'cookie',
  initialState,
  reducers: {
    commitCookieConsent: (state, action: PayloadAction<CookieConsentMap>) => {
      state.consent = action.payload;
      state.hasCompletedBanner = true;
    },
    clearCookieConsent: () => initialState,
  },
});

export const { commitCookieConsent, clearCookieConsent } = cookieSlice.actions;
export default cookieSlice.reducer;
